import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  SiteSettingsService,
  SocialLink
} from '../../services/site-setting.service';

interface SocialDisplayLink {
  name: string;
  key: string;
  url: string;
  color: string;
}

@Component({
  selector: 'app-social-links',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialLinksComponent implements OnInit {

  socials: SocialDisplayLink[] = [];

  private readonly socialColors:
    Record<string, string> = {
      facebook: '#1877F2',
      instagram: '#E1306C',
      tiktok: '#010101',
      youtube: '#FF0000',
      x: '#000000',
      threads: '#000000',
      linkedin: '#0A66C2',
      snapchat: '#FFFC00',
      pinterest: '#E60023',
      bluesky: '#1185FE',
      reddit: '#FF4500',
      twitch: '#9146FF',
      discord: '#5865F2',
      whatsapp: '#25D366',
      nextdoor: '#8ED500',
      yelp: '#D32323',
      googlebusiness: '#4285F4',
      other: '#555555'
    };
  constructor(
    private readonly siteSettingsService: SiteSettingsService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadSocialLinks();
  }

  private loadSocialLinks(): void {
    this.siteSettingsService
      .getSocialSettings()
      .subscribe({
        next: settings => {
          this.socials = (settings.links ?? [])
            .filter(link =>
              Boolean(link.platform?.trim()) &&
              Boolean(link.url?.trim())
            )
            .map(link =>
              this.createDisplayLink(link)
            );

          this.changeDetector.markForCheck();
        },
        error: error => {
          console.error(
            'Unable to load social media links:',
            error
          );

          this.socials = [];
          this.changeDetector.markForCheck();
        }
      });
  }

  private createDisplayLink(
    link: SocialLink
  ): SocialDisplayLink {
    const key = link.platform
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');

    return {
      name: this.getDisplayName(link.platform),
      key,
      url: link.url.trim(),
      color:
        this.socialColors[key] ??
        '#555555'
    };
  }

  private getDisplayName(
    platform: string
  ): string {
    const normalized =
      platform.trim().toLowerCase();

    if (normalized === 'googlebusiness') {
      return 'Google Business';
    }

    if (normalized === 'linkedin') {
      return 'LinkedIn';
    }

    if (normalized === 'youtube') {
      return 'YouTube';
    }

    if (normalized === 'tiktok') {
      return 'TikTok';
    }

    if (normalized === 'whatsapp') {
      return 'WhatsApp';
    }

    return platform.trim();
  }
}